import {
  BreakoutRoomAllIds,
  BreakoutRoomByUser,
  BreakoutRoomEntries,
  BreakoutRoomWithUserEntries,
  NormalizedRoomsState,
} from 'features/breakout-rooms/types';
import { UserEntries } from 'features/users/types';
import { translateBreakoutDefaultRoomName } from 'features/breakout-rooms/utils/translateBreakoutDefaultRoomName';

export const normalizeRooms = (rooms: BreakoutRoomWithUserEntries[]): NormalizedRoomsState => {
  const byId: BreakoutRoomEntries = {};
  const allIds: BreakoutRoomAllIds = [];
  const users: UserEntries = {};
  const roomByUser: BreakoutRoomByUser = {};

  for (const room of rooms) {
    const userIds: string[] = [];

    for (const user of room.users) {
      users[user.id] = user;
      userIds.push(user.id);
      roomByUser[user.id] = room.id;
    }

    const translatedRoomName = translateBreakoutDefaultRoomName(room.name);

    byId[room.id] = {
      id: room.id,
      name: translatedRoomName,
      users: userIds,
      originalName: room.name,
    };
    allIds.push(room.id);
  }

  return { byId, allIds, users, roomByUser };
};
